/* eslint-disable no-undef */
const img = "img/icons/svg/planting.svg"
import { formatDate } from '../filters/date';

const COLOR = "#20BBCC"
const FILL_COLOR = "rgba(13, 127, 123, 0.4)"
const COLOR_TITLE = "#0D7F7B"

export const drawPolygons = function(fields, crop) {
    return fields.map(field => {
        return {
            color: COLOR,
            fillcolor: FILL_COLOR,
            text: `
                <div style="display: flex; flex-direction: column;">
                    <div style="display: flex; flex-direction: column;">
                        <div style=" display: flex; flex-direction: row; margin-bottom: 4px">
                            <img style="margin-top: 1px;" src=${img} height="13" width="13">
                            <div style="color: ${COLOR_TITLE}; font-weight: bold; font-size: 13px; margin-left: 6px">${crop.name}</div>
                        </div>
                        <div style=" display: flex; flex-direction: row; margin-bottom: 4px">
                            <div style="font-weight: 600;">
                                Nome:
                            </div>
                            <div style="margin-left: 4px;">
                                ${field.name}
                            </div>
                        </div>
                        <div style=" display: flex; flex-direction: row; margin-bottom: 4px">
                            <div style="font-weight: 600;">
                                Tamanho:
                            </div>
                            <div style="margin-left: 4px;">
                                ${field.size && field.size.value ? `${field.size.value} ${field.size.unity}` : '-'}
                            </div>
                        </div>
                         <div style=" display: flex; flex-direction: row; margin-bottom: 4px">
                            <div style="font-weight: 600;">
                                Início:
                            </div>
                            <div style="margin-left: 4px;">
                                ${formatDate(crop ? crop.startDate: new Date())}
                            </div>
                        </div> <div style=" display: flex; flex-direction: row;">
                            <div style="font-weight: 600;">
                                Fim:
                            </div>
                            <div style="margin-left: 4px;">
                              ${formatDate(crop ? crop.endDate: new Date())}
                            </div>
                        </div>
                    </div>
                </div>
            `,
            latlngs: field.polygons ? field.polygons.map(polygon => [ polygon.latitude, polygon.longitude ] ) : []
        }
    })
};

export const drawPolygon = function(field, crop) {
    return {
        color: COLOR,
        fillcolor: FILL_COLOR,
        text: `
            <div style="display: flex; flex-direction: column;">
                <div style="display: flex; flex-direction: column;">
                    <div style=" display: flex; flex-direction: row; margin-bottom: 4px">
                        <div style="font-weight: 600;">
                            Nome:
                        </div>
                        <div style="margin-left: 4px;">
                            ${field.name ? field.name : '-'}
                        </div>
                    </div>
                    <div style=" display: flex; flex-direction: row">
                        <div style="font-weight: 600;">
                            Tamanho:
                        </div>
                        <div style="margin-left: 4px;">
                            ${field.size && field.size.value ? `${field.size.value} ${field.size.unity}` : '-'}
                        </div>
                    </div>
                </div>
            </div>
        `,
        latlngs: field.polygons ? field.polygons.map(polygon => [ polygon.latitude, polygon.longitude ] ) : []
    }
};

export const createMarker = function (color, selectedIcon) {
    const pragueIcon = `
        <path
            d="M 240.936 95.142 C 240.861 97.794 238.569 99.875 235.858 99.875 L 227.254 99.875 L 227.254 102.31 C 227.254 105.638 226.495 108.792 225.139 111.617 L 234.505 120.784 C 236.447 122.686 236.447 125.77 234.505 127.672 C 232.561 129.575 229.41 129.574 227.467 127.672 L 218.956 119.341 C 215.107 122.396 210.203 124.228 204.862 124.228 L 204.862 87.09 C 204.862 86.081 204.026 85.263 202.996 85.263 L 199.264 85.263 C 198.233 85.263 197.398 86.081 197.398 87.09 L 197.398 124.228 C 192.056 124.228 187.152 122.396 183.304 119.341 L 174.793 127.672 C 172.849 129.575 169.698 129.574 167.756 127.672 C 165.812 125.77 165.812 122.686 167.756 120.784 L 177.12 111.617 C 175.765 108.792 175.006 105.638 175.006 102.31 L 175.006 99.875 L 166.401 99.875 C 163.69 99.875 161.398 97.794 161.324 95.142 C 161.246 92.389 163.504 90.134 166.298 90.134 L 175.006 90.134 L 175.006 81.192 L 167.756 74.095 C 165.812 72.194 165.812 69.109 167.756 67.208 C 169.699 65.305 172.849 65.305 174.793 67.208 L 183.287 75.522 L 218.972 75.522 L 227.467 67.208 C 229.41 65.305 232.561 65.305 234.504 67.208 C 236.447 69.109 236.447 72.194 234.504 74.095 L 227.254 81.192 L 227.254 90.134 L 235.962 90.134 C 238.757 90.134 241.013 92.389 240.936 95.142 Z M 201.285 51.169 C 191.667 51.169 183.869 58.801 183.869 68.216 L 218.701 68.216 C 218.701 58.801 210.904 51.169 201.285 51.169 Z"
            style="fill: #FFFFFF;"
        />
    `
    const diseaseIcon = `
        <path
            d="M 247.681 65.13 C 246.996 63.026 244.557 61.832 242.229 62.452 L 239.438 63.206 C 237.398 59.734 234.272 56.962 230.483 55.232 L 231.182 52.801 C 231.793 50.676 230.389 48.505 228.045 47.954 C 225.689 47.398 223.307 48.676 222.699 50.798 L 222.005 53.215 C 220.168 53.158 217.164 53.232 209.697 55.212 L 208.902 53.19 C 208.088 51.121 205.746 50.027 203.301 50.778 C 201.021 51.513 199.83 53.784 200.64 55.856 L 201.435 57.88 C 197.631 59.374 194.021 61.182 190.599 63.231 L 189.138 61.449 C 187.513 59.693 184.929 59.333 182.99 60.642 C 181.052 61.956 180.646 64.446 182.104 66.205 L 183.576 67.993 C 180.442 70.408 177.581 73.098 174.96 75.973 L 172.91 74.612 C 170.972 73.317 168.221 73.704 166.781 75.485 C 165.35 77.257 165.779 79.745 167.735 81.039 L 169.782 82.395 C 167.593 85.506 165.671 88.801 164.082 92.264 L 161.695 91.519 C 159.396 90.805 156.91 91.906 156.123 93.983 C 155.331 96.065 156.549 98.318 158.838 99.04 L 161.248 99.793 C 159.059 106.909 159.213 109.166 159.33 110.877 L 156.477 111.645 C 154.153 112.268 152.833 114.48 153.524 116.584 C 154.272 118.872 156.865 119.839 158.973 119.262 L 161.746 118.515 C 163.736 121.913 166.836 124.69 170.706 126.458 L 169.995 128.937 C 169.532 130.395 170.474 133.909 174.24 133.909 C 176.189 133.909 177.967 132.724 178.482 130.934 L 179.186 128.474 C 181.071 128.537 185.805 128.62 191.189 125.419 L 193.302 127.393 C 194.233 128.261 197.103 129.585 199.502 127.476 C 201.24 125.946 201.28 123.43 199.594 121.855 L 197.343 119.754 C 198.784 117.687 199.847 115.36 200.317 112.793 C 200.536 111.598 200.886 110.447 201.269 109.313 C 203.237 110.151 204.067 110.638 205.353 110.638 C 207.001 110.638 208.576 109.795 209.324 108.353 C 210.355 106.369 209.413 104 207.22 103.065 L 205.054 102.144 C 208.763 97.163 213.526 94.618 213.628 94.559 L 214.593 96.545 C 215.567 98.539 218.136 99.464 220.378 98.579 C 222.427 97.691 223.598 95.348 222.621 93.337 L 221.632 91.289 C 222.636 91.036 223.636 90.772 224.681 90.613 C 227.783 90.144 230.567 89.023 232.993 87.496 L 235.454 89.517 C 237.169 90.929 239.953 90.936 241.646 89.24 C 243.273 87.613 243.137 85.101 241.34 83.629 L 238.95 81.664 C 241.04 78.488 242.086 74.768 241.815 70.866 L 244.734 70.079 C 247.053 69.45 248.364 67.231 247.681 65.13 Z M 182.879 109.7 C 177.986 109.7 174.017 106.086 174.017 101.63 C 174.017 97.173 177.986 93.56 182.879 93.56 C 187.775 93.56 191.76 97.174 191.76 101.63 C 191.76 106.085 187.79 109.7 182.879 109.7 Z M 197.649 86.835 C 195.203 86.835 193.233 85.027 193.233 82.799 C 193.233 80.57 195.203 78.916 197.649 78.916 C 200.097 78.916 201.914 80.721 201.914 82.799 C 201.914 85.035 200.104 86.835 197.649 86.835 Z"
            style="fill: #FFFFFF;"
        />
    `

    const plantIcon = `
        <path
            d="M 163.237 60.226 L 150.837 60.226 C 150.837 84.524 170.271 104.19 194.239 104.19 L 194.239 129.313 C 194.239 132.944 197.029 135.77 200.265 135.77 C 203.5 135.77 206.639 132.944 206.639 129.489 L 206.639 104.367 C 206.639 80.088 187.205 60.226 163.237 60.226 Z M 237.64 47.841 C 221.316 47.841 207.143 56.968 199.703 70.471 C 205.08 76.383 209.051 83.597 211.135 91.571 C 232.991 89.274 250.041 70.589 250.041 47.841 L 237.64 47.841 Z"
            style="fill: #FFFFFF;"
        />
    `

    const defaultIcon = `
        <circle
            transform="matrix(0.97523, 0, 0, 0.933246, -238.641068, -57.681877)" cx="452" cy="171" r="43.93176527297759"
            style="fill: #FFFFFF;"
        />
    `

    const icons = {
        "prague": pragueIcon,
        "disease": diseaseIcon,
        "plant": plantIcon
    }

    return L.divIcon({
        className: `agrointeli-custom-marker`,
        html: `
            <div style="width: 60px; margin-left: -25px; margin-top: -45px;">
                <svg
                    viewBox="0 0 500 500"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="matrix(0.967482, 0, 0, 1, 60.904694, 64.896721)">
                        <path
                            d="M 291.548 102.387 C 291.548 113.127 289.562 123.416 285.929 132.927 L 201.321 366.61 L 115.939 130.767 L 115.957 130.767 C 112.828 121.866 111.13 112.319 111.13 102.387 C 111.13 53.949 151.518 14.681 201.339 14.681 C 251.16 14.681 291.548 53.949 291.548 102.387 Z"
                            style="fill: ${color};"
                        />
                        ${icons[selectedIcon] || defaultIcon}
                    </g>
                </svg>
            </div>
        `
    })
}
